<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />

    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <div class="row align-items-end mb-3">
            <div class="col-lg-3 col-md-6 mb-2">
              <label for="operator_id">اپراتور</label>

              <select id="operator_id" v-model="filters.operator_id" class="form-control" @input="search">
                <option :value="null">
                  همه اپراتورها
                </option>

                <option v-for="operator in operators" :key="operator.id" :value="operator.id">
                  {{ [operator.name, operator.family].filter(Boolean).join(' ') }}
                </option>
              </select>
            </div>

            <div class="col-lg-3 col-md-6 mb-2">
              <label for="filter-phone">شماره موبایل راننده</label>
              <input id="filter-phone" v-model.trim="filters.phone" type="text" inputmode="numeric" class="form-control"
                placeholder="شماره موبایل" @input="search" />
            </div>

            <div class="col-lg-3 col-md-6 mb-2">
              <label for="filter-national-code">کد ملی راننده</label>
              <input id="filter-national-code" v-model.trim="filters.national_code" type="text" inputmode="numeric"
                class="form-control" placeholder="کد ملی" @input="search" />
            </div>

            <div class="col-lg-3 col-md-6 mb-2">
              <label for="filter-activity">رسته فعالیت</label>
              <select id="filter-activity" v-model="filters.activity_slug" class="form-control" @change="loadData">
                <option value="">همه فعالیت‌ها</option>
                <option v-for="activity in activities" :key="activity.id || activity.slug" :value="activity.slug">
                  {{ activity.label }}
                </option>
              </select>
            </div>

            <bita-datepicker ref="fromdate" type="date" id="activityReportFromDate"
              validation-container-class="col-lg-3 col-md-6 mb-2" name="from-date" label="از تاریخ تماس"
              inputClass="form-control" v-model="filters.fromDate" @change="search" />

            <bita-datepicker ref="todate" type="date" id="activityReportToDate"
              validation-container-class="col-lg-3 col-md-6 mb-2" name="to-date" label="تا تاریخ تماس"
              inputClass="form-control" v-model="filters.toDate" @change="search" />
          </div>

          <div class="d-flex align-items-center flex-wrap mb-3" style="gap: 8px">
            <bita-bootbutton type="danger" title="حذف فیلترها" @click.native="reset" />
          </div>

          <hr />

          <bita-grid ref="grid" :columns="gridColumns" :read-data="readData" :grid-server-side="true"
            :schema-total="'total'" :schema-data="'data'" :server-paging="true" :batch="true" :resizable="true"
            :page-size="30" />
        </div>
      </bita-ibox>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        {
          title: "گزارش تماس و فعالیت رانندگان",
          link: "/report/driver-activity",
          active: true,
        },
      ],
      operators: [],
      isLoadingGrid: false,
      activities: [],

      filters: {
        operator_id: null,
        phone: "",
        national_code: "",
        activity_slug: "",
        fromDate: "",
        toDate: "",
      },
    };
  },

  computed: {
    gridColumns() {
      return [
        {
          field: "id",
          title: "شناسه فعالیت",
          template: (e) => (e && e.id ? e.id : "-"),
          width: "90px",
        },
        {
          field: "driver_name",
          title: "نام راننده",
          template: (e) => {
            if (!e) return "-";
            const name = [e.driver_first_name, e.driver_last_name]
              .filter(Boolean)
              .join(" ");
            return name || "-";
          },
          width: "170px",
        },
        {
          field: "national_code",
          title: "کد ملی",
          template: (e) => (e && e.national_code ? e.national_code : "-"),
          width: "120px",
        },
        {
          field: "phone",
          title: "شماره موبایل راننده",
          template: (e) => (e && e.phone ? e.phone : "-"),
          width: "140px",
        },
        {
          field: "operator_name",
          title: "اپراتور ثبت‌کننده",
          template: (e) => {
            if (!e) return "-";
            const name = [e.operator_first_name, e.operator_last_name]
              .filter(Boolean)
              .join(" ");
            return name || "-";
          },
          width: "170px",
        },
        {
          field: "call_at",
          title: "تاریخ تماس",
          template: (e) =>
            e && e.call_at ? this.$getJalaliDateTime(e.call_at) : "-",
          width: "150px",
        },
        {
          field: "activity_label",
          title: "رسته فعالیت",
          template: (e) =>
            e && e.activity_label ? e.activity_label : "-",
          width: "180px",
        },
        {
          field: "description",
          title: "توضیحات فعالیت",
          template: (e) => (e && e.description ? e.description : "-"),
          width: "250px",
        },
        {
          field: "activity_created_at",
          title: "تاریخ ثبت فعالیت",
          template: (e) =>
            e && e.activity_created_at
              ? this.$getJalaliDateTime(e.activity_created_at)
              : "-",
          width: "155px",
        },
      ];
    },
  },

  mounted() {
    this.fetchActivities();
    this.fetchOperators();
  },

  methods: {
    fetchOperators() {
      this.$persistClient(
        "get",
        "users/search-by-role?role=support_jetbar&page_size=100"
      )
        .then((res) => {
          this.operators = res.data.data || [];
        })
        .catch((error) => {
          console.error("خطا در دریافت فهرست اپراتورها:", error);
          this.operators = [];
        });
    },
    fetchActivities() {
      this.$persistClient("get", "driver-activities")
        .then((res) => {
          const payload = res && res.data ? res.data : [];
          this.activities = Array.isArray(payload)
            ? payload
            : payload.data || [];
        })
        .catch((error) => {
          console.error("Driver activities loading failed:", error);
          this.activities = [];
          this.$izitoast(
            "error",
            "خطا",
            "دریافت فهرست رسته‌های فعالیت انجام نشد."
          );
        });
    },

    /** دریافت گزارش؛ پارامترها با callReport در Laravel هماهنگ هستند. */
    readData(e) {
      const page = (e && e.data && e.data.page) || 1;
      const pageSize = (e && e.data && e.data.pageSize) || 30;
      const params = new URLSearchParams();

      params.set("page", page);
      params.set("page_size", pageSize);

      if (this.filters.operator_id) {
        params.set("operator_id", this.filters.operator_id);
      }
      if (this.filters.phone) {
        params.set("phone", this.filters.phone);
      }
      if (this.filters.national_code) {
        params.set("national_code", this.filters.national_code);
      }
      if (this.filters.activity_slug) {
        params.set("activity_slug", this.filters.activity_slug);
      }
      if (this.filters.fromDate) {
        params.set("from", this.filters.fromDate);
      }
      if (this.filters.toDate) {
        params.set("to", this.filters.toDate);
      }

      const url = `drivers/activity-call-report?${params.toString()}`;
      this.isLoadingGrid = true;

      this.$persistClient("get", url)
        .then((res) => {
          // پاسخ paginate لاراول شامل data و total است.
          const result = (res && res.data) || {};
          e.success({
            data: result.data || [],
            total: result.total || 0,
          });
        })
        .catch((error) => {
          console.error("Driver activity report load failed:", error);
          e.success({ data: [], total: 0 });
          this.$izitoast(
            "error",
            "خطا",
            error.response && error.response.data && error.response.data.message
              ? error.response.data.message
              : "دریافت گزارش تماس و فعالیت انجام نشد."
          );
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },

    loadData() {
      if (
        this.$refs.grid &&
        typeof this.$refs.grid.loadDataSource === "function"
      ) {
        this.$refs.grid.loadDataSource();
      }
    },

    // جلوگیری از ارسال درخواست با هر کاراکتر تایپ‌شده
    search: _.debounce(function () {
      this.loadData();
    }, 500),

    reset() {
      this.filters = {
        operator: "",
        phone: "",
        national_code: "",
        activity_slug: "",
        fromDate: "",
        toDate: "",
      };
      this.loadData();
    },
  },
};
</script>

<style scoped>
.fade-enter {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 1s ease-in;
}

.fade-leave {
  opacity: 0.2;
}
</style>
